import { render } from "./RecentlyCompletedWork.vue?vue&type=template&id=7de28a6c"
import script from "./RecentlyCompletedWork.vue?vue&type=script&lang=js"
export * from "./RecentlyCompletedWork.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__